import React from 'react';
import AttendanceCalendarPresenter from './AttendanceCalendarPresenter';

function AttendanceCalendarController() {
  return <AttendanceCalendarPresenter />;
}
export default AttendanceCalendarController;
